// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"e3520834","453":"2e714c31","610":"dc566974"}[chunkId] + ".chunk.js";
};